import { combineReducers } from "redux";

function ContactsReducer() {
  const contactsInitialState = {
    error: null,
    loading: false,
    addContactLoading: false,
    addContactImageLoadingContactId: null,
    deleteContactLoading: false,
    contacts: null,
  };

  const contacts = (state = contactsInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_CONTACTS_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          contacts: null,
        };
      case "GET_CONTACTS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          contacts: payload,
        };
      case "GET_CONTACTS_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          contacts: null,
        };
      case "GET_IMAGE_INIT":
        return {
          ...state,
        };
      case "GET_IMAGE_SUCCESS":
        const contacts = state.contacts.filter((c) => true);

        for (let i = 0; i < contacts.length; i++) {
          if (contacts[i]["id"] == payload["contactId"]) {
            contacts[i]["image_url"] = payload["image_url"];
          }
        }

        return {
          ...state,
          loading: false,
          error: null,
          contacts: contacts,
        };
      case "GET_IMAGE_ERROR":
        return {
          ...state,
        };

      case "ADD_CONTACT_INIT":
        return {
          ...state,
          addContactLoading: true,
          error: null,
        };
      case "ADD_CONTACT_SUCCESS":
        return {
          ...state,
          addContactLoading: false,
          error: null,
        };
      case "ADD_CONTACT_ERROR":
        return {
          ...state,
          addContactLoading: false,
          error: payload,
        };
      case "ADD_IMAGE_INIT":
        return {
          ...state,
          addContactImageLoadingContactId: payload.contactId,
          error: null,
        };
      case "ADD_IMAGE_SUCCESS":
        return {
          ...state,
          addContactImageLoadingContactId: null,
          error: null,
        };
      case "ADD_IMAGE_ERROR":
        return {
          ...state,
          addContactImageLoadingContactId: false,
          error: payload,
        };

      case "DELETE_CONTACT_INIT":
        return {
          ...state,
          deleteContactLoading: true,
          error: null,
        };
      case "DELETE_CONTACT_SUCCESS":
        return {
          ...state,
          deleteContactLoading: false,
          error: null,
        };
      case "DELETE_CONTACT_ERROR":
        return {
          ...state,
          deleteContactLoading: false,
          error: payload,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    contacts,
  });
}

export default ContactsReducer();
